import React from 'react';
import { Field } from 'react-final-form';
import { FormField, FormHelp, Input, Label } from '@zillow/constellation-10';
import { FieldValidator, firstLastNameRegex, firstLastNameRegexErrorText } from '../../../validation/validation';
import { LAST_NAME } from '../../../constants/formFieldNames';

export default function LastNameField() {
  return (
    <Field
      name={LAST_NAME}
      format={(lastName) => lastName?.trim()}
      formatOnBlur
      render={({ input, meta }) => {
        const { touched, active, error } = meta;
        const isInvalid = touched && !active && Boolean(error);
        return (
          <FormField
            error={isInvalid}
            label={<Label>Legal last name</Label>}
            control={<Input {...input} />}
            description={
              isInvalid ? (
                <FormHelp>{error}</FormHelp>
              ) : (
                <FormHelp>Whitespaces are not allowed, use a hyphen “-” to split multiple last names</FormHelp>
              )
            }
          />
        );
      }}
      validate={(lastName) => {
        const errors = new FieldValidator(lastName)
          .required('Enter a last name')
          .maxLength(32)
          .regex(firstLastNameRegex, firstLastNameRegexErrorText)
          .build();

        return errors ? errors : null;
      }}
    />
  );
}
